module.exports = __webpack_public_path__ + "files/dcb6f91c9655a7fe4a352774eeccbea0.png";